var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"taskAdd"},[_c('NavTitle',{attrs:{"title":'ADD NEW TASK'}}),_c('div',{staticClass:"taskAdd-content"},[_c('TaskForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }